module.exports = __webpack_public_path__ + "img/autobus-breton.8be56a74.webp";